export default __webpack_public_path__ + "static/media/kitchen-icon.c8df8610.png";